<template>
  <v-dialog
    v-model="dialogOpen"
    max-width="600">
    <v-card>
      <v-card-title class="d-flex align-center grey lighten-4">
        <v-icon left>
          mdi-tune
        </v-icon>
        Capacity Settings — {{ factory ? factory.name : '' }}
        <v-spacer />
        <v-btn
          icon
          @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.defaultTentPcs"
              label="Tentative PCS"
              type="number"
              outlined
              dense
              suffix="pcs"
              min="0"
              hide-details="auto"
              hint="Tentative fallback capacity" />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.defaultProdPcs"
              label="Producing PCS"
              type="number"
              outlined
              dense
              suffix="pcs"
              min="0"
              hide-details="auto"
              hint="Producing fallback capacity" />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.defaultTentProduct"
              label="Tentative Products"
              type="number"
              outlined
              dense
              suffix="products"
              min="0"
              hide-details="auto"
              hint="Tentative product limit" />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.defaultProdProduct"
              label="Producing Products"
              type="number"
              outlined
              dense
              suffix="products"
              min="0"
              hide-details="auto"
              hint="Producing product limit" />
          </v-col>
        </v-row>

        <div class="text-caption grey--text text--darken-1 mt-4 mb-2 font-weight-medium">
          PRODUCTION TYPES
        </div>
        <v-chip-group
          v-model="form.productionTypes"
          multiple
          column>
          <v-chip
            v-for="pt in productionTypeOptions"
            :key="pt.value"
            :value="pt.value"
            filter
            outlined>
            <v-icon
              left
              x-small>
              {{ pt.icon }}
            </v-icon>
            {{ pt.label }}
          </v-chip>
        </v-chip-group>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn
          text
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="saving"
          @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import FactoryProvider from '@/resources/FactoryProvider'

const FactoryService = new FactoryProvider()

export default {
  name: 'FactoryCapacitySettingsDialog',
  props: {
    value: Boolean,
    factory: { type: Object, default: null }
  },
  data () {
    return {
      saving: false,
      form: {
        defaultTentPcs: 0,
        defaultProdPcs: 0,
        defaultTentProduct: 0,
        defaultProdProduct: 0,
        productionTypes: []
      },
      productionTypeOptions: [
        { value: 'WOVEN', label: 'Woven', icon: 'mdi-grid' },
        { value: 'JERSEY', label: 'Jersey', icon: 'mdi-tshirt-crew' },
        { value: 'ACTIVEWEAR', label: 'Activewear', icon: 'mdi-run' },
        { value: 'JEANS', label: 'Jeans', icon: 'mdi-hanger' },
        { value: 'KNIT', label: 'Knit', icon: 'mdi-vector-combine' },
        { value: 'BAG', label: 'Bag', icon: 'mdi-bag-personal' },
        { value: 'ACC', label: 'Acc', icon: 'mdi-necklace' },
        { value: 'FOOTWEAR', label: 'Footwear', icon: 'mdi-shoe-sneaker' },
        { value: 'EYEWEAR', label: 'Eyewear', icon: 'mdi-glasses' }
      ]
    }
  },
  computed: {
    dialogOpen: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  watch: {
    value (val) {
      if (val && this.factory) {
        this.form = {
          defaultTentPcs: this.factory.defaultTentPcs || 0,
          defaultProdPcs: this.factory.defaultProdPcs || 0,
          defaultTentProduct: this.factory.defaultTentProduct || 0,
          defaultProdProduct: this.factory.defaultProdProduct || 0,
          productionTypes: this.factory.productionTypes ? [...this.factory.productionTypes] : []
        }
      } else {
        this.form = { defaultTentPcs: 0, defaultProdPcs: 0, defaultTentProduct: 0, defaultProdProduct: 0, productionTypes: [] }
      }
    }
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar'
    }),
    async save () {
      if (!this.factory) return
      this.saving = true
      try {
        await FactoryService.updateOne(this.factory.id, this.form)
        this.$emit('saved')
        this.setSnackbar({ value: true, message: 'Capacity settings saved', type: 'success' })
      } catch (e) {
        console.error('save', e?.message || e)
        this.setSnackbar({
          value: true,
          message: `Error: ${e?.message || e}`,
          type: 'error'
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
